export default {
  item: {
    base: {
      header: {
        span: {
          fontWeight: 700
        }
      }
    }
  },
  content: {
    base: {
      span: {
        color: 'primary'
      }
    }
  }
};